module.exports = __webpack_public_path__ + "img/modern_corporate.6f641f4b.jpg";